/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import CopyableText from '@/ui-kit/components/CopyableTextKit';
import type { JSONSchema } from '@tarslib/utils/lib/json-schema/type';
import { Popover } from 'aui';
import React from 'react';

export type JsonSchemaEnumProps = {
  name: React.ReactNode;
  enumDescriptions: JSONSchema['x-app-enum'] | undefined;
};

export function JsonSchemaEnum(props: JsonSchemaEnumProps) {
  const { enumDescriptions, name } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const [open, setOpen] = React.useState(false);

  return (
    <Popover
      placement="top"
      title={null}
      content={() => {
        const enums =
          enumDescriptions?.map((res) => {
            return {
              label: String(res.value !== undefined ? res.value : ''),
              name: res.name,
              value: res.description !== undefined ? res.description : '',
            };
          }) ?? [];
        return (
          <div className="flex max-h-[200px] overflow-y-auto">
            <div>
              <div className="border-b px-3 py-1.5 text-base font-500 text-secondary">
                {clientI18n('enumeratedValue')}
              </div>
              {enums.map((res) => {
                return (
                  <div key={res.label} className="h-8 border-b px-3 py-1.5 font-400 text-color">
                    <CopyableText text={res.label} copyText={res.label} />
                  </div>
                );
              })}
            </div>
            {enums.some((val) => val.name !== '') && (
              <div>
                <div className="border-b px-3 py-1.5 text-base font-500 text-secondary">
                  {clientI18n('name')}
                </div>
                {enums.map((res) => {
                  return (
                    <div key={res.label} className="h-8 border-b px-3 py-1.5 font-400 text-color">
                      {res.name}
                    </div>
                  );
                })}
              </div>
            )}
            <div>
              <div className="border-b px-3 py-1.5 text-base font-500 text-secondary">
                {clientI18n('description')}
              </div>
              {enums.map((res) => {
                return (
                  <div key={res.label} className="h-8 border-b px-3 py-1.5 font-400 text-color">
                    <CopyableText text={res.value} copyText={res.value} />
                  </div>
                );
              })}
            </div>
          </div>
        );
      }}
      open={open}
      onOpenChange={setOpen}
    >
      <span className="cursor-pointer" onMouseOver={() => setOpen(true)}>
        {name}
      </span>
    </Popover>
  );
}
